/**
 * <pre>
 * Voting enums.
 *
 * Summary of responsibilities:
 *
 *  - enumerate any commonly used values
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Voting
 * @namespace
 *
 * @type {Object}
 */
const Enums = {
  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Voting strategy. */

  // Show CTA after voting.
  STRATEGY_VOTING_CTA:      'strategy.voting.cta',
  // Post to users Facebook wall after voting.
  STRATEGY_VOTING_POSTWALL: 'strategy.voting.posttowall',

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Fraud strategy. */

  // No fraud prevention.
  STRATEGY_FRAUD_NONE:                 'strategy.fraud.none',
  // Always present Google Captcha overlay.
  STRATEGY_FRAUD_CAPTCHA:              'strategy.fraud.recaptcha',
  // Dynamically present (Smart) Google Captcha overlay when backend asks for it.
  STRATEGY_FRAUD_DYNCAPTCHA:           'strategy.fraud.dynamiccaptcha',
  // Always present Cloudflare Turnstile Captcha
  STRATEGY_FRAUD_TURNSTILE:            'strategy.fraud.turnstile',
  // Dynamically present (Smart) Cloudflare Turnstile Captcha
  STRATEGY_FRAUD_DYNCAPTCHA_TURNSTILE: 'strategy.fraud.dynamiccaptchaturnstile',
};

export default Enums;
